import React, { useState } from "react";
import "./research.css";

function Research() {
  const [research] = useState(null);

  return (
    <div className="background-color mx-2">
      <div className="header research-and-data"></div>
      <div id="projects" className="section">
        <div className="w-container">
          <h1 className="h1">Research and Data</h1>
          <p className="p">
            Gammadda Door-to-Door campaign is the initial step of the Gammadda
            process. It was launched to identify the socio-economic challenges
            faced by individuals and villages in the most rural areas of the
            country, By identifying those issues which are not appeared on the
            surface will help Gammadda to design the focus of the projects.
          </p>
        </div>
      </div>

      <div className="container">
        <h2 className="heading-3 research">Door to Door Research</h2>
        <div className="row justify-content-center">
          <div className="research col-md-4 col-sm-6 col-12 text-center">
            <img
              src="https://cdn.newsfirst.lk/gammadda/66abaebec6aed14e82f57ccb_2-p-500.jpg"
              loading="lazy"
              alt=""
              className="image-10"
            />
            <div className="about-text research">
              <strong className="about-text-bold">
                Gammadda D2D Report Edition I
              </strong>
              <br />
              <br />
              This is the first edition of the Gammadda research.
            </div>
            <a
              href="https://cdn.newsfirst.lk/gammadda/66abaebec6aed14e82f57ccc_Gammadda%20Report%202016.pdf"
              target="_blank"
              className="button research w-button"
            >
              View Report
            </a>
          </div>
          <div className="research col-md-4 col-sm-6 col-12 text-center">
            <img
              src="https://cdn.newsfirst.lk/gammadda/66abaebec6aed14e82f57bd3_Untitled-1_07-p-500.png"
              loading="lazy"
              alt=""
              className="image-10"
            />
            <div className="about-text research">
              <strong className="about-text-bold">
                Gammadda D2D Report Edition II
                <br />‍<br />
              </strong>
              An initiative by News 1st in collaboration with University of
              Peradeniya
              <br />
            </div>
            <a
              href="http://cdn.newsfirst.lk/gammadda/research-and-data/Gammadda%20Report%202017.pdf"
              target="_blank"
              className="button research w-button"
            >
              View Report
            </a>
          </div>
          <div className="col-md-4 col-sm-6 col-12 text-center">
            <img
              src="https://cdn.newsfirst.lk/gammadda/66abaebec6aed14e82f57bd2_Untitled-1_08%2520(2)-p-500.png"
              loading="lazy"
              alt=""
              className="image-10"
            />
            <p className="about-text research">
              <strong className="about-text-bold">
                Gammadda D2D Report Edition III
              </strong>
              <br />
              <br />
              Research report on socio economic and environmental challenges
              in rural Sri Lanka
            </p>
            <a
              href="https://cdn.newsfirst.lk/gammadda/research-and-data/Gammadda%20%20Report%20%202018.pdf"
              target="_blank"
              className="button research w-button"
            >
              View Report
            </a>
          </div>
          <div className="research col-md-4 col-sm-6 col-12 text-center">
            <img
              src="https://cdn.newsfirst.lk/gammadda/research-and-data/D2DVI.png"
              loading="lazy"
              alt=""
              className="image-10"
            />
            <div className="about-text research">
              <strong className="about-text-bold">
                Gammadda D2D Report Edition IV
              </strong>
              <br />
              <br />
              This is the fourth edition of the Gammadda research.
            </div>
            <a
              href="https://cdn.newsfirst.lk/gammadda/research-and-data/Gammadda%20Door%20to%20Door%20-%20Edition%204.pdf"
              target="_blank"
              className="button research w-button"
            >
              View Report
            </a>
          </div>
          <div className="research col-md-4 col-sm-6 col-12 text-center">
            <img
              src="https://cdn.newsfirst.lk/gammadda/research-and-data/6749724fdacd68b46171036b_Screenshot%202024-11-29%20132008.png"
              loading="lazy"
              alt=""
              className="image-10"
            />
            <div className="about-text research">
              <strong className="about-text-bold">
                Gammadda D2D Report Edition V
              </strong>
              <br />
              <br />
              Research report on socio economic and environmental challenges in
              rural Sri Lanka
            </div>
            <a
              href="https://cdn.newsfirst.lk/gammadda/66abaebec6aed14e82f57cca_Gammadda%20Door%20to%20door%20Report%202020%20Final_WithoutHistry-compressed%20(2).pdf"
              target="_blank"
              className="button research w-button"
            >
              View Report
            </a>
          </div>
          <div className="col-md-4 col-sm-6 col-12 text-center">
            <img
              src="https://cdn.newsfirst.lk/gammadda/67496f30426bff380ad82095_Report_Cover%202022.png"
              loading="lazy"
              alt=""
              className="image-10"
            />
            <div className="about-text research">
              <strong className="about-text-bold">
                Gammadda D2D Report Edition VI
              </strong>
              <br />
              <br />
              Sixth edition of the research on socio-economic and environmental
              challenges in Sri Lanka.
            </div>
            <a
              href="https://cdn.newsfirst.lk/gammadda/67496f57b2122279a626d70e_Gammadda%20D2D%20Report%202022%20Pages.pdf"
              target="_blank"
              className="button research w-button"
            >
              View Report
            </a>
          </div>
          <div className="research col-md-4 col-sm-6 col-12 text-center">
            <img
              src="https://cdn.newsfirst.lk/gammadda/680723d60127119eca1e4240_gammadda_D2D_report-p-500.jpg"
              loading="lazy"
              alt=""
              className="image-10"
            />
            <div className="about-text research">
              <strong className="about-text-bold">
                Gammadda D2D Report Edition VII
                <br />‍
              </strong>
              <br />
              Seventh edition of the research on socio-economic, environmental
              challenges and Health Issues in Sri Lanka.
            </div>
            <a
              href="https://cdn.newsfirst.lk/gammadda/6807244fbe60a730cf10f383_Gammadda%20D2D%20Report%20-%202023.pdf"
              target="_blank"
              className="button research w-button"
            >
              View Report
            </a>
          </div>
        </div>
      </div>


      <div className="container">
        <h2 className="heading-3 research">Science and Technology</h2>
        <div className="row justify-content-center">
          <div className="research col-md-4 col-sm-6 col-12 text-center">
            <img
              src="https://cdn.newsfirst.lk/gammadda/research-and-data/66abaebec6aed14e82f57bd6_Screenshot%202020-10-18%20at%2013.29.21.png"
              loading="lazy"
              alt=""
              className="image-10"
            />
            <div className="about-text research">
              <strong className="about-text-bold">Waven Wewa Report</strong>
              <br />
              <br />
              The ancient hydraulic heritage of Bellankadawala
            </div>
            <a
              href="https://cdn.newsfirst.lk/gammadda/research-and-data/Wawen%20Wawa%20Project%20FINAL.pdf"
              target="_blank"
              className="button research w-button"
            >
              View Report
            </a>
          </div>
        </div>
      </div>

      <div className="container">
        <h2 className="heading-3 research">Gammadda Scholar</h2>
        <div className="row justify-content-center">
          <div className="research col-md-4 col-sm-6 col-12 text-center">
            <img
              src="https://cdn.newsfirst.lk/gammadda/research-and-data/Claire%20Lopez%20Project%20Cover.png"
              loading="lazy"
              className="image-10"
            />
            <div className="about-text periodical">
              <strong className="about-text-bold">Addressing Causes of Environmental Disease in Rural Sri Lanka</strong>
              <br />
            </div>
            <a
              href="https://cdn.newsfirst.lk/gammadda/research-and-data/Final%20Gammadda%20Report.pdf"
              target="_blank"
              className="button research w-button"
            >
              View Report
            </a>
          </div>

          <div className="research col-md-4 col-sm-6 col-12 text-center">
            <img
              src="https://cdn.newsfirst.lk/gammadda/research-and-data/66abaebec6aed14e82f57cd6_Purified%20Water%20for%20All.jpeg"
              loading="lazy"
              className="image-10"
            />
            <div className="about-text periodical">
              <strong className="about-text-bold">
                Purified water for all
              </strong>
              <br />
            </div>
            <a
              href="https://cdn.newsfirst.lk/gammadda/research-and-data/Purified%20Water%20for%20All.pdf"
              target="_blank"
              className="button research w-button"
            >
              View Report
            </a>
          </div>
          <div className="research col-md-4 col-sm-6 col-12 text-center">
            <img
              src="https://cdn.newsfirst.lk/gammadda/research-and-data/66abaebec6aed14e82f57cd5_Perceptions%20and%20Solutions%20to%20the%20Human-Elephant%20Conflict.jpeg"
              loading="lazy"
              className="image-10"
            />
            <div className="about-text ">
              <strong className="about-text-bold">
                Perceptions and solutions to <br />
                the human - elephant conflict
              </strong>
              <br />
            </div>
            <a
              href="https://cdn.newsfirst.lk/gammadda/research-and-data/Perceptions%20and%20Solutions%20to%20the%20Human-Elephant%20Conflict.pdf"
              target="_blank"
              className="button research w-button"
            >
              View Report
            </a>
          </div>
          <div className="research col-md-4 col-sm-6 col-12 text-center">
            <img
              src="https://cdn.newsfirst.lk/gammadda/research-and-data/66abaebec6aed14e82f57cd4_Domestic%20Violence%20Faced%20by%20Women%20and%20Children%20in%20Sri%20Lanka.jpeg"
              loading="lazy"
              alt=""
              className="image-10"
            />
            <div className="about-text ">
              <strong className="about-text-bold">
                Domestic violence faced by women and children in Sri Lanka
              </strong>
              <br />
            </div>
            <a
              href="https://cdn.newsfirst.lk/gammadda/research-and-data/Domestic%20Violence%20Faced%20by%20Women%20and%20Children%20in%20Sri%20Lanka.pdf"
              target="_blank"
              className="button research w-button"
            >
              View Report
            </a>
          </div>
          <div className="research col-md-4 col-sm-6 col-12 text-center">
            <img
              src="https://cdn.newsfirst.lk/gammadda/research-and-data/66abaebec6aed14e82f57cd3_Climate%20Change%20%E2%80%93%20Impact%20on%20Agriculture%2C%20Health%2C%20Economy%20and%20Livelihood.jpeg"
              loading="lazy"
              className="image-10"
            />
            <div className="about-text periodical">
              <strong className="about-text-bold">
                Climate Change - impact on agriculture, health, economy and
                livelihood
              </strong>
              <br />
            </div>
            <a
              href="https://cdn.newsfirst.lk/gammadda/research-and-data/Climate%20Change%20%E2%80%93%20Impact%20on%20Agriculture%2C%20Health%2C%20Economy%20and%20Livelihood.pdf"
              target="_blank"
              className="button research w-button"
            >
              View Report
            </a>
          </div>
          <div className="research col-md-4 col-sm-6 col-12 text-center">
            <img
              src="https://cdn.newsfirst.lk/gammadda/research-and-data/66abaebec6aed14e82f57cd2_Elevate%20Education%20During%20the%20Next%20Decade%20in%20Sri%20Lanka.jpeg"
              loading="lazy"
              className="image-10"
            />
            <div className="about-text ">
              <strong className="about-text-bold">
                Elevate education during the <br />
                next decade in Sri Lanka
              </strong>
              <br />
            </div>
            <a
              href="https://cdn.newsfirst.lk/gammadda/research-and-data/Elevate%20Education%20During%20the%20Next%20Decade%20in%20Sri%20Lanka.pdf"
              target="_blank"
              className="button research w-button"
            >
              View Report
            </a>
          </div>
          <div className="research col-md-4 col-sm-6 col-12 text-center">
            <img
              src="https://cdn.newsfirst.lk/gammadda/research-and-data/66abaebec6aed14e82f57cd1_Period%20Poverty%20in%20Sri%20Lanka.jpeg"
              loading="lazy"
              alt=""
              className="image-10"
            />
            <div className="about-text ">
              <strong className="about-text-bold">
                Period poverty in Sri Lanka
              </strong>
              <br />
            </div>
            <a
              href="https://cdn.newsfirst.lk/gammadda/research-and-data/Period%20Poverty%20in%20Sri%20Lanka.pdf"
              target="_blank"
              className="button research w-button"
            >
              View Report
            </a>
          </div>
          <div className="research col-md-4 col-sm-6 col-12 text-center">
            <img
              src="https://cdn.newsfirst.lk/gammadda/research-and-data/66abaebec6aed14e82f57cd0_Modern%20Rural%20Village%20Plan.jpeg"
              loading="lazy"
              className="image-10"
            />
            <div className="about-text periodical">
              <strong className="about-text-bold">Modern rural village</strong>
              <br />
            </div>
            <a
              href="https://cdn.newsfirst.lk/gammadda/research-and-data/Modern%20Rural%20Village%20Plan%20-%20Gammadda%20(1).pdf"
              target="_blank"
              className="button research w-button"
            >
              View Report
            </a>
          </div>
          <div className="research col-md-4 col-sm-6 col-12 text-center">
            <img
              src="https://cdn.newsfirst.lk/gammadda/research-and-data/66abaebec6aed14e82f57ccf_Saemaul%20Undong%20and%20Gammadda.jpeg"
              loading="lazy"
              className="image-10"
            />
            <div className="about-text ">
              <strong className="about-text-bold">
                Saemaul undong and gammadda
              </strong>
              <br />
            </div>
            <a
              href="https://cdn.newsfirst.lk/gammadda/research-and-data/Saemaul%20Undong%20and%20Gammadda-%20A%20Literature%20Review.pdf"
              target="_blank"
              className="button research w-button"
            >
              View Report
            </a>
          </div>
          <div className="research col-md-4 col-sm-6 col-12 text-center">
            <img
              src="https://cdn.newsfirst.lk/gammadda/674971bd2c79f7b89c5c09f9_COVER-p-500.jpg"
              loading="lazy"
              className="image-10"
            />
            <div className="about-text ">
              <strong className="about-text-bold">
                Climate Change - Pathways to Adaptation and resilience
              </strong>
              <br />
            </div>
            <a
              href="https://cdn.newsfirst.lk/gammadda/674966e475224ac4ae48a87d_Climate%20Change%20Impacts%20in%20Rural%20Sri%20Lanka_%20Pathways%20to%20Adapation%20and%20Resilience.pdf"
              target="_blank"
              className="button research w-button"
            >
              View Report
            </a>
          </div>
          <div className="research col-md-4 col-sm-6 col-12 text-center">
            <img
              src="https://cdn.newsfirst.lk/gammadda/675fab2e949967aecf0e8797_Purple%20Modern%20Webinar%20Online%20Business%20Poster%20(1)-p-500.jpg"
              loading="lazy"
              className="image-10"
            />
            <div className="about-text ">
              <strong className="about-text-bold">
                CHALLENGES AND POTENTIAL SOLUTIONS TO FOOD INSECURITY IN RURAL
                SRI LANKA
              </strong>
              <br />
            </div>
            <a
              href="https://cdn.newsfirst.lk/gammadda/675fab2ef309084ac687eee4_Bray_Gammadda%20Food%20Insecurity%20Research.pdf"
              target="_blank"
              className="button research w-button"
            >
              View Report
            </a>
          </div>
        </div>
      </div>


      <div className="container">
        <h2 className="heading-3 research">Periodicals</h2>
        <div className="row justify-content-center" >
          <div className="research col-md-4 col-sm-6 col-12 text-center">
            <img
              src="https://cdn.newsfirst.lk/gammadda/research-and-data/66abaebec6aed14e82f57bd8_Screenshot%202020-10-18%20at%2013.39.33.png"
              loading="lazy"
              className="image-10"
            />
            <div className="about-text periodical">
              <strong className="about-text-bold">March/April/May 2019</strong>
              <br />
            </div>
            <a
              href="https://cdn.newsfirst.lk/gammadda/research-and-data/Voice%20of%20Gammadda%20-%20Magazine%20-%20%20Volum%202.pdf"
              target="_blank"
              className="button research w-button"
            >
              View Magazine
            </a>
          </div>
          <div className="research col-md-4 col-sm-6 col-12 text-center">
            <img
              src="https://cdn.newsfirst.lk/gammadda/research-and-data/66abaebec6aed14e82f57bd7_Screenshot%202020-10-18%20at%2013.38.40.png"
              loading="lazy"
              className="image-10"
            />
            <div className="about-text ">
              <strong className="about-text-bold">January/Feb 2019</strong>
              <br />
            </div>
            <a
              href="https://cdn.newsfirst.lk/gammadda/research-and-data/Voice%20of%20Gammadda%20-%20Magazine%20-%20Volum%201.pdf"
              target="_blank"
              className="button research w-button"
            >
              View Magazine
            </a>
          </div>
          <div className="research col-md-4 col-sm-6 col-12 text-center">
            <img
              src="https://cdn.newsfirst.lk/gammadda/66abaebec6aed14e82f57c6e_Screenshot_169.png"
              loading="lazy"
              alt=""
              className="image-10"
            />
            <div className="about-text ">
              <strong className="about-text-bold">May/june/july 2020</strong>
              <br />
            </div>
            <a
              href="https://cdn.newsfirst.lk/gammadda/research-and-data/magazine%202020.pdf"
              target="_blank"
              className="button research w-button"
            >
              View Magazine
            </a>
          </div>
          <div className="research col-md-4 col-sm-6 col-12 text-center">
            <img
              src="https://cdn.newsfirst.lk/gammadda/66abaebec6aed14e82f57c71_Screenshot_174.png"
              loading="lazy"
              height="400"
              alt=""
              className="image-10"
            />
            <div className="about-text periodical">
              <strong className="about-text-bold">
                August/december 2020
              </strong>
              <br />
            </div>
            <a
              href="https://cdn.newsfirst.lk/gammadda/research-and-data/Final%20VOG-2020%20AUG-DEC%20low%20res.pdf"
              target="_blank"
              className="button research w-button"
            >
              View Magazine
            </a>
          </div>
          <div className="research  col-md-4 col-sm-6 col-12 text-center">
            <img
              src="https://cdn.newsfirst.lk/gammadda/66abaebec6aed14e82f57cb3_Screenshot_345.png"
              loading="lazy"
              height="400"
              alt=""
              className="image-10"
            />
            <div className="about-text periodical">
              <strong className="about-text-bold">january/july 2021</strong>
              <br />
            </div>
            <a
              href="https://cdn.newsfirst.lk/gammadda/research-and-data/Voice%20of%20Gammadda%20-%20Revisions%2003%20(1).pdf"
              target="_blank"
              className="button research w-button"
            >
              View Magazine
            </a>
          </div>
          <div className="research col-md-4 col-sm-6 col-12 text-center">
            <img
              src="https://cdn.newsfirst.lk/gammadda/66abaebec6aed14e82f57cc5_Screenshot_132-p-500.png"
              loading="lazy"
              className="image-10"
            />
            <div className="about-text periodical">
              <strong className="about-text-bold">
                August/january 2021/22
              </strong>
              <br />
            </div>
            <a
              href="https://cdn.newsfirst.lk/gammadda/research-and-data/VOG%20-%20Aug-Dec_V12%20-%20Final.pdf"
              target="_blank"
              className="button research w-button"
            >
              View Magazine
            </a>
          </div>
          <div className="research  col-md-4 col-sm-6 col-12 text-center">
            <img
              src="https://cdn.newsfirst.lk/gammadda/research-and-data/66abaebec6aed14e82f57ccd_VOG%20-%20Aug%20Cover%20(1).png"
              loading="lazy"
              className="image-10"
            />
            <div className="about-text periodical">
              <strong className="about-text-bold">JANUARY/AUGUST 2022</strong>
              <br />
            </div>
            <a
              href="https://cdn.newsfirst.lk/gammadda/research-and-data/Voice%20of%20Gammadda%20-%20Magazine_Nov%2001_V2.pdf"
              target="_blank"
              className="button research w-button"
            >
              View Magazine
            </a>
          </div>
          <div className="research   col-md-4 col-sm-6 col-12 text-center">
            <img
              src="https://cdn.newsfirst.lk/gammadda/67c97b6971ea435d46894684_home-page-p-500.png"
              loading="lazy"
              className="image-10"
            />
            <div className="about-text periodical">
              <strong className="about-text-bold">2023/2024 Issue</strong>
              <br />
            </div>
            <a
              href="https://cdn.newsfirst.lk/assets/VOG%20-%202023-2024_Final.pdf"
              target="_blank"
              className="button research w-button"
            >
              View Magazine
            </a>
          </div>
        </div>
      </div>


    </div>
  );
}

export default Research;
